import $ from "@modules/jquery";

// SELECTOR_AUTO_FILTERS ==> Sezione filtri, contiene modale + form 
// SELECTOR_AUTO_GRID ==> Sezione griglia, contiene auto

export function AutoFiltersBlock(SELECTOR_AUTO_FILTERS, SELECTOR_AUTO_GRID) {
    const FORM = $(SELECTOR_AUTO_FILTERS).find("form");
    const MODAL = $(SELECTOR_AUTO_FILTERS).find("#modal-auto-filters");
    const FILTER_CHIPS = $(SELECTOR_AUTO_FILTERS).find(".spk-auto-active-filters");
    const GRID = $(SELECTOR_AUTO_GRID);


    const getFilterValues = () => {
        const formData = {};
        FORM.serializeArray().forEach(({ name, value }) => {
            if (!formData[name]) {
                formData[name] = [];
            }
            formData[name].push(value);
        });
        // console.table(formData);
        return formData;
    }


    const updateFilterChips = () => {
        const formData = getFilterValues();
        FILTER_CHIPS.empty();

        // Calcola il numero di filtri attivi
        const filterCount = Object.values(formData).reduce((acc, values) => acc + values.length, 0);
        const filterCTA = $(SELECTOR_AUTO_FILTERS).find("#auto-grid-filter");
        
        // Aggiorna il contatore
        filterCTA.find("sup").text(filterCount);
        
        // Rimuovi tutte le icone esistenti
        filterCTA.find(".clear-all-filters").remove();
        
        if (filterCount > 0) {
            // Se ci sono filtri attivi, aggiungi la classe 'active' e rimuovi 'inactive'
            filterCTA.removeClass("inactive").addClass("active");
            
            // Aggiungi l'icona 'X' per rimuovere tutti i filtri
            const activeIcon = $(`<span class='ml-4 cursor-pointer clear-all-filters' title="Rimuovi tutti i filtri">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block">
                    <path d="M1 1L16.4503 16.6493" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" />
                    <path d="M1 16.6494L16.4503 1.00009" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </span>`);
            // aggiungi classi per lo stile al button con class chip btn btn_secondary_outline
           if(filterCTA.hasClass("active")) {
            filterCTA.addClass("w-full sm:w-auto justify-between");
         }          
           

            
            // Aggiungi event listener per il click sull'icona X
            activeIcon.on("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                // Deseleziona tutti i checkbox del form
                FORM.find('input[type="checkbox"]').prop("checked", false);
                
                // Svuota tutti i campi di input (se necessario)
                FORM.find('input[type="text"], input[type="number"]').val('');
                
                // Ripristina i select ai valori di default
                FORM.find('select').prop('selectedIndex', 0);
                
                // Invia il form per aggiornare i filtri
                FORM.trigger("submit");
            });
            
            filterCTA.append(activeIcon);
        } else {
            // Se non ci sono filtri attivi, aggiungi la classe 'inactive' e rimuovi 'active'
            filterCTA.removeClass("active").addClass("inactive");
             if(filterCTA.hasClass("inactive")){
            filterCTA.removeClass("w-full sm:w-auto justify-between");
           }
        }
        
        // Create chips for each selected filter
        Object.keys(formData).forEach(filterGroup => {
            const filterValues = formData[filterGroup];
            filterValues.forEach(value => {
                label = $(`input[value="${value}"]`).attr("data-label");
                const chip = $(`<span class="filter-item chip btn btn_secondary_outline font-bold flex items-center flex-wrap relative group">
                                <span class="capitalize pr-6">${label}</span>
                                <span class='absolute right-4 cursor-pointer'>
                                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="inline-block">
                                        <path d="M1 1L16.4503 16.6493" stroke="#3F3F3F" stroke-width="2" stroke-linecap="round" class="group-hover:stroke-white transition-smooth"/>
                                        <path d="M1 16.6494L16.4503 1.00009" stroke="#3F3F3F" stroke-width="2" class="group-hover:stroke-white transition-smooth" stroke-linecap="round"/>
                                    </svg>
                                </span>
                            </span>`);

                chip.on("click", () => {
                    // Remove the chip and update the filters
                    chip.remove();
                    FORM.find(`input[name="${filterGroup}"][value="${value}"]`).prop("checked", false);
                    FORM.trigger("submit");
                });
                FILTER_CHIPS.append(chip);
            });
        });
    }


    // Apply filters on submit
    FORM.on("submit", (e) => {
        e.preventDefault();
        const formData = getFilterValues();

        // Apply all filters
        GRID.find("[data-auto-id]").each(function () {
            const $item = $(this);
            // Check if item matches all filter groups (AND between groups)
            const matchesAllGroups = Object.keys(formData).every(filterGroup => {
                const filterValues = formData[filterGroup];
                const itemValue = $item.attr(`data-auto-${filterGroup}`);
                
                // If no values selected for this filter group, consider it a match
                if (filterValues.length === 0) return true;
                
                // OR logic within a filter group - match if any value matches
                return filterValues.some(value => itemValue.toLowerCase() === value.toLowerCase());
            });
            
            if (matchesAllGroups) {
                $item.fadeIn();
            } else {
                $item.fadeOut();
            }
        });

        // Update filter chips
        updateFilterChips();

        // Close modal
        MODAL.find("[data-modal-hide]").click();
    });
}
